export const SET_STORE_ID = 'SET_STORE_ID'
